import React, { FC } from 'react'
import styled from 'styled-components'

import { FacetedResultsMetaCount } from '../../../graphql/search'
import { pluralize } from '../../../utils/textTools'

export interface ProductCountProps {
  className?: string
  loading?: boolean
  productCount?: FacetedResultsMetaCount
  productCountText: string
}

const ProductCount: FC<ProductCountProps> = ({
  className,
  loading,
  productCount,
  productCountText,
}) => {
  const countAll = productCount?.all || 0
  const countCurrent = productCount?.current || 0

  return (
    <div className={className}>
      {loading
        ? 'LOADING RESULTS...'
        : `${countAll === 1 ? 1 : `1-${countCurrent} OF ${countAll}`} ${pluralize({
            count: countAll,
            word: productCountText,
          }).toUpperCase()}`}
    </div>
  )
}

const StyledProductCount = styled(ProductCount)(({ theme }) => ({
  display: 'none',
  boxSizing: 'border-box',
  alignItems: 'center',
  fontSize: '14px',
  fontFamily: theme.fontFamilies.robotoCondensed,
  backgroundColor: 'transparent',
  height: '60px',
  lineHeight: '16px',
  letterSpacing: '0.09em',
  paddingLeft: '87px',
  '@media(min-width: 992px)': {
    display: 'flex',
    flex: '0 0 calc(100% - 500px)',
  },
}))

export default StyledProductCount
